import { render } from "./VNavigation.vue?vue&type=template&id=47100c9b&scoped=true"
import script from "./VNavigation.vue?vue&type=script&lang=js"
export * from "./VNavigation.vue?vue&type=script&lang=js"

import "./VNavigation.vue?vue&type=style&index=0&id=47100c9b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47100c9b"]])

export default __exports__